import Vue from 'vue';
Vue.filter('toCurrency', function (value) {
  if (typeof value !== "number") {
    return value;
  }
  let currency = localStorage.getItem('app_currency');
  let locale = localStorage.getItem('app_locale') || 'en-GB';
  let formatter = new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0
  });
  return formatter.format(value);
});
